export default __webpack_public_path__ + "static/media/img8.1d520be0.PNG";